import axios from '@/axios';

/**
 * GET /api/resume/parsed-data - load parsed resume data for editing
 */
export async function getParsedData() {
  const { data } = await axios.get('/api/resume/parsed-data');
  return data;
}

/**
 * POST /api/resume/upload - upload base resume (PDF/DOCX/TXT). Returns { message, filename, extractedData }.
 */
export async function uploadResume(file) {
  const formData = new FormData();
  formData.append('resume', file);
  const { data } = await axios.post('/api/resume/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

/**
 * PUT /api/resume/parsed-data - save edited resume data
 */
export async function updateParsedData(payload) {
  const { data } = await axios.put('/api/resume/parsed-data', payload);
  return data;
}
